import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import ApiService from "../services/globalBibleApi";

const LanguageSelect = ({ name, onChange, value, completedOnly }) => {
  const [languageOptions, setLanguageOptions] = useState([]);

  useEffect(() => {
    ApiService.listLanguages().then(languages => {
      const options = languages
        .filter(({ complete }) => complete || !completedOnly)
        // eslint-disable-next-line
        .map(({ id, name, complete }) => ({
          label: `${name}${complete ? "" : "*"} (${id})`,
          value: id
        }));
      setLanguageOptions(options);
    });
  }, [completedOnly]);

  // eslint-disable-next-line
  const handleChange = ({ value }) => {
    onChange({
      target: {
        name,
        value
      }
    });
  };

  return (
    <Select
      name={name}
      value={languageOptions.find(({ value: id }) => id === value)}
      onChange={handleChange}
      options={languageOptions}
    />
  );
};

LanguageSelect.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  completedOnly: PropTypes.bool
};

LanguageSelect.defaultProps = {
  completedOnly: false,
  value: ""
};

export default LanguageSelect;
